export const IsRelProjectEnum = {
  ALL: null,
  Y: 'Y',
  N: 'N',
};
export const RelProjectOption = [
  {
    label: '全部',
    value: IsRelProjectEnum.ALL,
  },
  {
    label: '是',
    value: IsRelProjectEnum.Y,
  },
  {
    label: '否',
    value: IsRelProjectEnum.N,
  },
];
